import React from "react";
import { Link } from "react-router-dom";

/*eslint-disable */

declare const window: any;

interface SimuladorComponentProps {
  modelo: any;
  setModelo: any;
  modelos: any;
  setModelos: any;
  version: any;
  setVersion: any;
  politica_1: any;
  setPolitica_1: any;
  politica_2: any;
  setPolitica_2: any;
  setCurrentIndex: any;
  vehiculos: any;
}

const SimuladorComponent: React.FC<SimuladorComponentProps> = ({
  modelo,
  setModelo,
  modelos,
  setModelos,
  version,
  setVersion,
  politica_1,
  setPolitica_1,
  politica_2,
  setPolitica_2,
  setCurrentIndex,
  vehiculos,
}) => {
  return (
    <div className="content-simulador-component">
      {/* H1 - Título principal de la página */}
      <h1>Simulador de cuotas</h1>

      <div className="step-content-simulador-component">
        <div className="step_1 active" onClick={() => setCurrentIndex(0)}>
          <span>1</span>
        </div>
        <div className="line"></div>
        <div
          className="step_2"
          onClick={() => {
            modelo !== "" && politica_1 && politica_2
              ? setCurrentIndex(1)
              : null;
          }}
        >
          <span>2</span>
        </div>
      </div>

      {/* H2 - Subtítulo */}
      <h2 className="subtitle-content-simulador-component">
        Selecciona un vehículo para calcular los pagos.
      </h2>

      <div className="internal-content-simulador-component">
        <div className="vehiculo-internal-content-simulador-component">
          <div
            className={`asset-vehiculo-internal-content-simulador-component ${
              modelo !== "" ? "active" : ""
            }`}
          >
            {modelo !== "" ? (
              <img
                src={`https://manager.hyundaicolombia.co/${modelo !== undefined ? vehiculos?.find((item: any) => item.slug === modelo)?.versions?.find((e: any) => e.name === version)?.image?.url : vehiculos[0]}`}
                alt={`Imagen del modelo ${modelo} versión ${version}`}
              />
            ) : null}
          </div>
          <div className="politicas-vehiculo-internal-content-simulador-component">
            *Los valores y precios publicados son de referencia y pueden variar
            sin previo aviso.
          </div>
          <div className="politicas-vehiculo-internal-content-simulador-component">
            *Las imágenes son ilustrativas, algunas características de los
            vehículos de las imágenes pueden variar.
          </div>
        </div>

        <div className="seleccion-internal-content-simulador-component">
          <div className="modelo-seleccion-internal-content-simulador-component">
            {/* LABEL (se mantiene como label, no es título) */}
            <label htmlFor="">Modelo</label>
            <select
              name=""
              id=""
              value={modelo}
              onChange={(e) => {
                (setModelo(e.target.value),
                  setVersion(
                    vehiculos.find((item: any) => item.slug === e.target.value)
                      ?.versions[0].name,
                  ));
              }}
            >
              {modelo === "" ? <option value=""></option> : null}
              {vehiculos.map((item: any, index: number) => (
                <option key={index} value={item.slug}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div
            className={`version-seleccion-internal-content-simulador-component ${
              modelo === "" ? "oculto" : ""
            }`}
          >
            <label htmlFor="">Versión</label>
            <select
              name=""
              id=""
              value={version}
              onChange={(e) => setVersion(e.target.value)}
            >
              {vehiculos
                ?.find((item: any) => item.slug === modelo)
                ?.versions?.map((item: any, index: number) => (
                  <option key={index} value={item.name}>
                    {item.name}
                  </option>
                ))}
            </select>
          </div>

          <div className="politica-seleccion-internal-content-simulador-component">
            <div>
              <input
                type="checkbox"
                name="politicas-1"
                id=""
                checked={politica_1}
                onChange={(e) => setPolitica_1(e.target.checked)}
              />
            </div>
            <div>
              <label htmlFor="">
                Acepto política de datos, términos y condiciones.
              </label>
            </div>
          </div>

          <div className="politica-seleccion-internal-content-simulador-component">
            <div>
              <input
                type="checkbox"
                name="politicas-1"
                id=""
                checked={politica_2}
                onChange={(e) => setPolitica_2(e.target.checked)}
              />
            </div>
            <div>
              <label htmlFor="">
                Autorizo la transferencia y transmisión de mis datos para las
                finalidades de publicidad a las compañías de su grupo.
              </label>
            </div>
          </div>

          <div className="terminos-seleccion-internal-content-simulador-component">
            Estamos comprometidos con tu privacidad, por ello, en Hyundai
            Colombia S.A.S. junto con nuestros aliados oficiales te aseguramos
            que utilizaremos la información que nos proporcionas para
            comunicarnos contigo acerca de nuestros productos, servicios,
            ofertas, invitaciones, encuestas, entre otras finalidades y
            contenidos relevantes para ti. Puedes darte de baja de estas
            comunicaciones en cualquier momento. Para obtener más información
            consulta nuestra
            <br></br>
            <a
              href="https://hyundaicolombia.co/politica-proteccion-datos"
              target="_blank"
              rel="noopener noreferrer"
            >
              Politica de privacidad
            </a>{" "}
            <a
              href="https://hyundaicolombia.co/terminos-condiciones"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terminos y condiciones
            </a>
          </div>
        </div>
      </div>

      {/* BOTÓN SIN MODIFICAR */}
      <div
        className={`btn-next-content-simulador-component ${
          modelo !== "" && politica_1 && politica_2 ? "active" : ""
        }`}
        onClick={() => setCurrentIndex(1)}
      >
        Siguiente
      </div>
    </div>
  );
};

export default SimuladorComponent;
